export class WorkflowDashboardSummaryResultDto {
    status: string;
    itemCount: number;
    sequence: number;

    get statusText(): string {
        return `${this.status} (Count = ${this.itemCount})`;
    }
}
